import {
    BUSCAR_ARQUIVOS_LOADING, BUSCAR_ARQUIVOS_SUCCESS, BUSCAR_ARQUIVOS_FAIL,
} from '../actionTypes';


const initialState = {
    arquivos: [],
    isLoading: false,
    wasLoaded: false,
    error: null,
};


const arquivos = (state = initialState, { type, payload }) => {
    switch (type) {
        case BUSCAR_ARQUIVOS_LOADING:            
            return {
                ...state,
                isLoading: true,
                wasLoaded: false,
                error: null,
            }                        
        case BUSCAR_ARQUIVOS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                wasLoaded: true,
                arquivos: payload.arquivos
            }                   
        case BUSCAR_ARQUIVOS_FAIL:
            return {
                ...state,
                isLoading: false,
                wasLoaded: false,
                arquivos: [], 
                error: payload.error                        
            }          
        default:
            return state;
    }
}

export default arquivos